import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/shipment/yandex'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class PostingsYandexApi {

    static async getOrders({ data = { shop: undefined, skladName: undefined, status: undefined, subStatus: undefined, fromDate: undefined, toDate: undefined, shipmentDate: undefined, page: undefined, limit: undefined }, ...params }) {
        return await fetchService({ url: '/getorders', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async collectOrders({ data = { shop: undefined, postings: undefined, skladName: undefined, orderId: undefined, shipmentId: undefined }, ...params }) {
        return await fetchService({ url: '/collectorders', method: 'POST', data, ...params })
    }

    static async loadReturns({ data = { shop: undefined }, ...params }) {
        return await fetchService({ url: '/loadreturns', method: 'POST', data, ...params })
    }

    // static async updateFinances({ data = { shop: undefined, shipmentId: undefined }, ...params }) {
    //     return await fetchService({ url: '/updatefinances', method: 'POST', data, ...params })
    // }

    static async getOrdersExcel({ data = { shop: undefined, skladName: undefined, status: undefined, subStatus: undefined, fromDate: undefined, toDate: undefined, shipmentDate: undefined }, ...params }) {
        return await fetchService({ url: '/excelorders', method: 'POST', data, options: { download: true }, ...params })
    }



    // static async setCorrectPrice({ data = { shop: undefined, skladName: undefined, status: undefined, subStatus: undefined, fromDate: undefined, toDate: undefined, shipmentDate: undefined }, ...params }) {
    //     return await fetchService({ url: '/setprices', method: 'PATCH', data, ...params })
    // }

}